import { Paging, Tab } from 'api/types';
import { NetworkBaseTableView } from 'components/NetworkBaseTableComponent/types';
import { TableDataResponse } from 'features/types';

export type GetJoinNetworksTableFilters = {
  text?: string;
  tab: string;
}

export type GetJoinNetworksTable = {
  paging: Paging;
  filters: GetJoinNetworksTableFilters;
  onBehalfOfOrganizationId?: string;
};

export type JoinNetworkTableView = NetworkBaseTableView & {
  isJoined: boolean;
};

export type NetworkJoinForm = {
  programsIds: string[];
  agreementsChecked?: boolean;
};

type GetJoinSelectListFilters = {
  text?: string;
  networkId: string;
};

export type GetJoinSelectList = {
  filters: GetJoinSelectListFilters;
  paging: Paging;
  onBehalfOfOrganizationId?: string;
};

export type JoinNetworkData = {
  name: string;
  description?: string;
  isJoined: boolean;
  agreements?: string[];
};

export type NetworkJoinState = {
  requestData: GetJoinNetworksTable;
  data: {
    tableDataIsLoading: boolean;
    tabsIsLoading: boolean;
    tableData: TableDataResponse<JoinNetworkTableView>;
    joinDataIsLoading: boolean;
    joinData: JoinNetworkData | null;
    tabs: Tab[];
  };
};


export enum JoinNetworkTableTabs {
  Joined = 'Joined',
  Discover = 'Discover',
  Pending = 'Pending',
  Declined = 'Declined',
}
